import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import PageTitle from '@/components/v2/PageTitle.vue';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import PaginatorMixin from '@/helpers/mixins/PaginatorMixin';
import CleverTapEventsMixin from '@/helpers/vue_mixins/v3/CleverTapEventsMixin';
import FaqForm from '@/components/v2/FaqForm.vue';
import faqCreate from '@/plugins/graphql/mutations/v2/faq-create.gql';
import Faqs from '@/plugins/graphql/queries/v2/faqs.gql';
import FaqMixin from '@/helpers/vue_mixins/v2/ecommerce/FaqMixin';
import ImageUploadMixin from '@/helpers/vue_mixins/v2/ImageUploadMixin';
import UpdateFaqButton from '@/plugins/graphql/mutations/v3/update-faq-button.gql';
let FaqCreate = class FaqCreate extends Mixins(AlertMixin, RouterParamsAppMixin, PaginatorMixin, CleverTapEventsMixin, Mixins(ImageUploadMixin, FaqMixin)) {
    mounted() {
        const fromButton = this.$route.params.fromButton === 'true';
        if (!fromButton) {
            this.$store.commit('toggleReadySuccessMessage', false);
        }
    }
    async onSubmit(form) {
        this.mutationRequestOnFlight();
        await this.create(form)
            .then(() => {
            this.successNotification('FAQ created successfully.');
            this.goToFaqsPage();
        })
            .catch((e) => {
            this.errorNotification(e.message);
        })
            .finally(() => {
            this.requestDone();
        });
    }
    async create(form) {
        const inputImages = form.images.map((input) => input.file);
        const appUuid = this.appUUID;
        return this.$apollo
            .mutate({
            mutation: faqCreate,
            variables: {
                input: {
                    question: form.question,
                    answer: form.answer,
                    appUuid,
                    images: inputImages,
                },
            },
            update: (cache, { data }) => {
                const queryOptions = {
                    query: Faqs,
                    variables: {
                        appUuid,
                        first: this.perPage,
                        after: null,
                    },
                };
                const { fetchAllFaqs } = cache.readQuery({
                    ...queryOptions,
                });
                if (!fetchAllFaqs) {
                    return;
                }
                const cachedFaqs = {
                    ...fetchAllFaqs,
                };
                cachedFaqs.edges.unshift({
                    node: data.faqCreate.faq,
                    __typename: 'FaqEdges',
                });
                cache.writeQuery({
                    ...queryOptions,
                    data: {
                        fetchAllFaqs: cachedFaqs,
                    },
                });
            },
        })
            .then(({ data }) => {
            if (!data || !data.faqCreate) {
                console.error('faqCreate mutation failed or returned null', data);
                return;
            }
            this.successNotification(`FAQ Added Successfully!`);
            if (!data.faqCreate.hasSubmittedFaq && this.$route.params.fromButton) {
                this.$store.commit('setTodoSuccessMessage', "You've successfully added your first FAQ entry. Clear, informative FAQs help customers make informed purchasing decisions.");
            }
            return this.$apollo.mutate({
                mutation: UpdateFaqButton,
                variables: {
                    input: {
                        appUuid,
                    },
                },
            });
        });
    }
};
FaqCreate = __decorate([
    Component({
        components: {
            PageTitle,
            FaqForm,
        },
    })
], FaqCreate);
export default FaqCreate;
